import { CHART_LAYOUT } from "./render";

export const tooltips = {
  "CS-Circles Solutions Ltd.": {
    showAfterChapter: -1,
    text: "Circles Solutions reportedly enabled the sale of malware to the United Arab Emirates, with which Israel had no official connections.",
  },
  "OSY Technologies SARL": {
    showAfterChapter: 2,
    text: "As a holding company, OSY Technologies brought together an additional three key subsidiary companies: CS-Circles Solutions Ltd. (under IOTA Holdings Ltd.), Westbridge Technologies, and Q Cyber Technologies SARL.",
  },
  "Q Cyber Technologies SARL": {
    showAfterChapter: -1,
    text: "Despite lacking official relations with Israel, Saudi Arabia’s purchase of Pegasus was reportedly enabled by Q Cyber Technologies SARL, NSO's affiliate company based in Luxembourg.",
  },
  "Westbridge Technologies Inc.": {
    showAfterChapter: -1,
    text: "While NSO is forbidden by Israel’s Ministry of Defence from operating in the US, its affiliate Westbridge Technologies reportedly marketed a version of Pegasus called Phantom to local US law enforcement.",
  },
};

export const MAIN_COMPANY = "NSO Group Technologies Ltd.";

export const companiesWithNameTooltip = {
  [CHART_LAYOUT.HORIZONTAL]: [
    "NSO Group Technologies Ltd.",
    "Francisco Partners", // TODO add to chart
    "Novalpina Capital", // TODO add to chart
    "OSY Technologies SARL",
    "Q Cyber Technologies SARL",
    "Westbridge Technologies Inc.",
  ],
  [CHART_LAYOUT.VERTICAL]: [
    "NSO Group Technologies Ltd.",
    "Francisco Partners", // TODO add to chart
    "Novalpina Capital", // TODO add to chart
    "OSY Technologies SARL",
    "Q Cyber Technologies SARL",
    "Westbridge Technologies Inc.",
  ],
};
